
import React, { Component } from "react";
import { connect } from "react-redux";
import { assessmentActions } from "../../../_actions";
import Footer from "./Footer";
import CartHeader from "../MyCart/CartHeader";
import moment from "moment";

class OrderConfirm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      otp_code: "",
      notFoundText: "",
      showLogin: true,
      failureMSG: "",
      failureOTPMSG: "",
      quantity: 1,
      activeTab: 1,
      showLoader: 0
    };
  }

  handleTabClick = (tabIndex) => {
    this.setState({ activeTab: tabIndex });
  };

  componentDidMount() {
    this.props.dispatch(assessmentActions.userAssessmentUserProfile());
    this.props.dispatch(assessmentActions.getOrderBookList({}, true));


    console.log("window.location--->", window.location.hash)
    let pathname = window.location.hash;
    let sCode = pathname.replace('#/assessment/order-complete/', '')

    console.log("pathname///////////////////--------------------->", pathname)


    console.log("sCode///////////////////--------------------->", sCode)



    let data = {
      sCode: sCode
    };
    console.log("data--->", data)

    this.props.dispatch(assessmentActions.createSuccessOrderBook(data));
    // this.props.dispatch(assessmentActions.saveSuccessOrderBook(data));

  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.user.userAssessmentMyCartSuccess) {
      return {
        ...nextProps,
        showLogin: false,
      };
    }
    if (nextProps.user.getEmployeeStatusSucess) {
      return {
        ...nextProps,
        notFoundText: "Success!",
      };
    }
    if (nextProps.user.getEmployeeStatusFailed) {
      return {
        ...nextProps,
        notFoundText: "Employee not found!",
      };
    } else {
      return {
        ...nextProps,
      };
    }
  }

  logout = () => {
    this.props.dispatch(assessmentActions.AssessmentUserLogout(this.props));
  };

  gotoPage = (field) => {
    this.props.history.push(`/assessment/` + field);
  };
  
  handleSignInPage = () => {
    localStorage.removeItem('route')
    localStorage.setItem('route', this.props.history.location.pathname)
    this.props.history.push(`/assessment/sign-in`);
  };

  loadAssessmentCode = () => {
    this.setState({ showLoader: 1 })
    this.props.dispatch(assessmentActions.saveSuccessOrderBook());
    setTimeout(() => {
      this.setState({ showLoader: 2 })
      // this.gotoPage("assessment-code")
    }, 5000)
  }


  render() {
    let { assessment } = this.props;
    let { userAssessmentUserProfileData, getOrderBookListData } = assessment;
    let { showLoader } = this.state;

    console.log("getOrderBookListData-->", getOrderBookListData);

    function getDetails(field, type, orderPack) {
      if (type === 2) {
        return field &&
          orderPack &&
          orderPack["productId"] &&
          orderPack["productId"][field]
          ? orderPack["productId"][field]
          : "";
      } else if (type === 3) {
        return field && orderPack && orderPack[field] ? orderPack[field] : "";
      } else {
        return field && getOrderBookListData && getOrderBookListData[0] && getOrderBookListData[0][field]
          ? getOrderBookListData[0][field]
          : "";
      }
    }



    return (
      <div className="">
        {/* <Header 
          handleSignInPage={this.handleSignInPage}
          userDetails={userAssessmentUserProfileData}
          logout={this.logout}
        /> */}

        <CartHeader
          handleSignInPage={this.handleSignInPage}
          userDetails={userAssessmentUserProfileData}
          logout={this.logout}
          stage={3}
        />

        <div className="flex items-center justify-center mx-auto mt-10 ">
          <div className="w-full px-4 mx-auto 2xl:w-9/12 xl:w-11/12 xl:px-0">
            <div className="flex flex-col-reverse md:flex-row justify-between items-center   bg-[#E8F5E9] md:p-10 p-6 w-full">
              <div className="w-full space-y-6">
                <div>
                  <h1 className="md:text-4xl text-3xl font-medium text-[#3D405B] md:text-left text-center">
                    Order Successful
                  </h1>
                  <p className="m-1 mt-2">You order has been successfully placed. Now you can access you assessment code.</p>
                </div>
                <div className="flex flex-col w-full gap-4 md:flex-row">
                  <button
                    onClick={() => this.gotoPage("products")}
                    className="bg-white text-[#3D405D] font-medium w-full lg:w-[270px] justify-center duration-150 transition-all py-3 px-8 md:rounded uppercase space-x-2 flex items-center  cursor-pointer text-lg"
                  >
                    <span>continue purchase</span>
                  </button>


                  {showLoader === 0 ?
                    <button
                      onClick={() => this.loadAssessmentCode()}
                      className="bg-[#2196F3] hover:bg-[#55aef6] text-[#fff] font-medium  w-full lg:w-[270px] justify-center duration-150 transition-all py-3 px-8 md:rounded uppercase space-x-2 flex items-center  cursor-pointer text-lg"
                    >
                      <span>Generate Code</span>
                    </button>
                    : null}

                  {showLoader === 1 ?
                    <button
                      className="bg-[#b3b3b3] hover:bg-[#b3b3b3] text-[#fff] font-medium  w-full lg:w-[270px] justify-center duration-150 transition-all py-3 px-8 md:rounded uppercase space-x-2 flex items-center  cursor-pointer text-lg"
                    >
                      <span>Please Wait ...</span>
                    </button>
                    : null}



                  {showLoader === 2 ?
                    <button
                      onClick={() => this.gotoPage("assessment-code")}
                      className="bg-[#4CAF50] hover:bg-[#43A047] text-[#fff] font-medium  w-full lg:w-[270px] justify-center duration-150 transition-all py-3 px-8 md:rounded uppercase space-x-2 flex items-center  cursor-pointer text-lg"
                    >
                      <span>Assessment Code</span>
                    </button>
                    : null}


                </div>
              </div>
              <div className="flex justify-center ">

                <svg
                  width="200"
                  height="200"
                  viewBox="0 0 280 245"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M226.853 56.6006C226.853 49.8246 215.51 38.4821 208.734 38.4821C215.51 38.4821 226.853 27.1395 226.853 20.3635C226.853 27.1395 238.195 38.4821 244.971 38.4821C238.195 38.4821 226.853 49.8246 226.853 56.6006Z"
                    fill="#4CAF50"
                  />
                  <path
                    d="M245.346 183.873C245.346 177.573 234.8 167.027 228.5 167.027C234.8 167.027 245.346 156.482 245.346 150.182C245.346 156.482 255.892 167.027 262.192 167.027C255.892 167.027 245.346 177.573 245.346 183.873Z"
                    fill="#4CAF50"
                  />
                  <path
                    d="M49.642 59.818C49.642 55.534 42.4715 48.3635 38.1875 48.3635C42.4715 48.3635 49.642 41.1929 49.642 36.9089C49.642 41.1929 56.8126 48.3635 61.0966 48.3635C56.8126 48.3635 49.642 55.534 49.642 59.818Z"
                    fill="#4CAF50"
                  />
                  <path
                    opacity="0.5"
                    d="M37.5455 226.545C37.5455 212.502 14.0433 189 0 189C14.0433 189 37.5455 165.498 37.5455 151.454C37.5455 165.498 61.0476 189 75.0909 189C61.0476 189.005 37.5455 212.502 37.5455 226.545Z"
                    fill="#4CAF50"
                  />
                  <path
                    d="M37.5391 203.786C37.5391 198.258 28.2813 188.997 22.75 188.997C28.2787 188.997 37.5391 179.737 37.5391 174.208C37.5391 179.737 46.7995 188.997 52.3282 188.997C46.7944 189 37.5391 198.255 37.5391 203.786Z"
                    fill="#4CAF50"
                  />
                  <path
                    d="M209.804 96.0746C207.125 93.2743 204.353 90.3887 203.308 87.8514C202.342 85.5272 202.285 81.675 202.228 77.9436C202.121 71.0068 202.008 63.146 196.542 57.6804C191.076 52.2148 183.216 52.1011 176.279 51.9945C172.547 51.9377 168.695 51.8808 166.371 50.9142C163.841 49.8694 160.948 47.0975 158.148 44.418C153.244 39.7058 147.671 34.3682 140.251 34.3682C132.831 34.3682 127.266 39.7058 122.355 44.418C119.555 47.0975 116.669 49.8694 114.132 50.9142C111.822 51.8808 107.955 51.9377 104.224 51.9945C97.2871 52.1011 89.4263 52.2148 83.9607 57.6804C78.4951 63.146 78.4169 71.0068 78.2748 77.9436C78.2179 81.675 78.1611 85.5272 77.1945 87.8514C76.1497 90.3816 73.3778 93.2743 70.6983 96.0746C65.9861 100.979 60.6484 106.551 60.6484 113.971C60.6484 121.391 65.9861 126.956 70.6983 131.867C73.3778 134.668 76.1497 137.553 77.1945 140.091C78.1611 142.415 78.2179 146.267 78.2748 149.998C78.3814 156.935 78.4951 164.796 83.9607 170.262C89.4263 175.727 97.2871 175.841 104.224 175.948C107.955 176.004 111.808 176.061 114.132 177.028C116.662 178.073 119.555 180.845 122.355 183.524C127.259 188.236 132.831 193.574 140.251 193.574C147.671 193.574 153.237 188.236 158.148 183.524C160.948 180.845 163.834 178.073 166.371 177.028C168.695 176.061 172.547 176.004 176.279 175.948C183.216 175.841 191.076 175.727 196.542 170.262C202.008 164.796 202.121 156.935 202.228 149.998C202.285 146.267 202.342 142.415 203.308 140.091C204.353 137.561 207.125 134.668 209.804 131.867C214.517 126.963 219.854 121.391 219.854 113.971C219.854 106.551 214.517 100.986 209.804 96.0746ZM172.704 100.936L132.902 140.738C132.374 141.266 131.747 141.686 131.057 141.972C130.367 142.258 129.627 142.405 128.879 142.405C128.132 142.405 127.392 142.258 126.702 141.972C126.012 141.686 125.385 141.266 124.857 140.738L107.799 123.68C106.732 122.613 106.133 121.166 106.133 119.657C106.133 118.148 106.732 116.701 107.799 115.634C108.866 114.567 110.313 113.968 111.822 113.968C113.331 113.968 114.778 114.567 115.845 115.634L128.879 128.676L164.658 92.8905C165.186 92.3622 165.814 91.9432 166.504 91.6573C167.194 91.3714 167.934 91.2242 168.681 91.2242C169.428 91.2242 170.168 91.3714 170.858 91.6573C171.548 91.9432 172.175 92.3622 172.704 92.8905C173.232 93.4188 173.651 94.0459 173.937 94.7362C174.223 95.4264 174.37 96.1662 174.37 96.9133C174.37 97.6604 174.223 98.4002 173.937 99.0904C173.651 99.7806 173.232 100.408 172.704 100.936Z"
                    fill="#4CAF50"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>

        {getDetails("orderNumber") ?
          <section className="flex flex-col w-full gap-10 px-4 mx-auto mb-10 2xl:w-9/12 xl:w-11/12 xl:px-0 lg:flex-row ">
            <div className="lg:w-[65%] w-[100%] py-10 ">
              <div className="border">
                <div className="flex justify-between p-4 bg-gray-100 border-b">
                  <div className="flex items-center space-x-4">
                    <div>
                      <h1 className="md:text-2xl text-xl font-medium text-[#3D405B]">
                        Order No: #{getDetails("orderNumber")}
                      </h1>{" "}
                      <span className="md:text-base text-sm text-[#3D405B]/70">
                        <span className="pr-2">Order Placed</span>
                        {moment(new Date(parseInt(getDetails("createdAt"))))
                          .utcOffset("+05:30")
                          .format("ddd, Do MMM, YYYY")}
                      </span>
                    </div>
                  </div>
                  <div className="pt-3">
                    <span className="md:text-base text-sm text-[#3D405B]/70">
                      (
                      {getDetails("orderPacks") &&
                        getDetails("orderPacks").length > 0
                        ? getDetails("orderPacks").length
                        : 0}{" "}
                      items)
                    </span>
                  </div>
                </div>

                <div className="p-6 divide-y">
                  {getDetails("orderPacks") && getDetails("orderPacks").length > 0
                    ? getDetails("orderPacks").map((orderPack) => (
                      <>
                        <div className="flex flex-row items-start gap-4 py-3 md:gap-6 md:items-center md:py-3 ">
                          <div className="flex items-center w-20 h-20 cursor-pointer md:w-32 md:h-32">
                            <img
                              src="/img/assessment/Rectangle.png"
                              className="w-20 h-20 md:w-32 md:h-32 overflow-cover"
                            />{" "}
                          </div>

                          <div className="flex-1 w-full space-y-4 md:space-y-6 ">
                            <div className="text-[#3D405B] flex  2xl:flex-row flex-col md:gap-4 gap-2 justify-between w-full ">
                              <h1 className="text-lg 2xl:text-2xl md:text-xl line-clamp-2">
                                {getDetails("name", 2, orderPack)}
                              </h1>
                              <h1 className="text-lg font-semibold 2xl:text-2xl md:text-xl">
                                <span className="font-[roboto]">  ₹</span>{getDetails("total", 3, orderPack)}
                              </h1>
                            </div>
                            <div className="flex flex-row items-center gap-2 text-[#3D405B]">
                              <span className="font-medium ">Qty:</span>
                              <div className="flex ">
                                <span className="text-base font-semibold text-center md:text-lg">
                                  {getDetails("quantity", 3, orderPack)}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    ))
                    : null}
                </div>
              </div>
            </div>

            <div className="lg:w-[35%] w-full md:py-10 text-[#3D405B] ">
              <div className="border">
                <div className="flex items-center justify-start p-4 px-6 space-x-4 bg-gray-100">
                  <h1 className="2xl:text-2xl xl:text-xl  text-xl  text-[#3D405B]">
                    Order Summary
                  </h1>{" "}
                  <span className="xl:text-lg text-base text-[#3D405B]/70 ">
                    (
                    {getDetails("orderPacks") &&
                      getDetails("orderPacks").length > 0
                      ? getDetails("orderPacks").length
                      : 0}{" "}
                    items)
                  </span>
                </div>

                <div className="p-3 px-6">
                  <div className="space-y-8 text-lg md:text-xl">
                    <div className="flex items-center justify-between capitalize">
                      <p className="">Subtotal</p>
                      <p className="font-medium "> <span className="font-[roboto]">₹</span>{getDetails("sum")}</p>
                    </div>
                    <div className="flex items-center justify-between py-6 capitalize border-t-2 border-dashed ">
                      <p className="font-bold ">Total Payable</p>
                      <p className="font-bold "> <span className="font-[roboto]">₹</span>{getDetails("total")}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          : null}


        <Footer />
      </div>
    );
  }
}
OrderConfirm.defaultProps = {
  center: { lat: 26.953021, lng: 75.739797 },
  zoom: 15,
};
function mapStateToProps(state) {
  //console.log("state  ", state);
  const { loggingIn } = state.authentication;
  const { questions, user, assessment } = state;
  return {
    loggingIn,
    questions,
    user,
    assessment,
  };
}

export default connect(mapStateToProps)(OrderConfirm);
